var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H4A4 4 0 0 0 .02 4L0 40l8-8h28a4.01 4.01 0 0 0 4-4V4a4.01 4.01 0 0 0-4-4M8 14h24v4H8zm16 10H8v-4h16zm8-12H8V8h24z"
  })));
};
export default SvgChat;